import { buildMetaPurchase } from './metaPixel';
import { safeGetItem, safeSetItem } from './safeStorage';
export const TIKTOK_READY_EVENT = 'jlastore:tiktok-ready';
let pixelId = '', readyId = '', lastPage = '';
let readyTimer = null;
const ready = () => window.dispatchEvent(new Event(TIKTOK_READY_EVENT));
function activeClient(id) {
  try {
    const instance = window.ttq?.instance?.(id);
    // Bootstrap methods are queued on arrays. The loaded SDK returns a real instance
    // with page/track, but does not expose the bootstrap's ready() method.
    if (!instance || Array.isArray(instance) || typeof instance.page !== 'function' || typeof instance.track !== 'function') return null;
    const instances = window.ttq.instances?.();
    return Array.isArray(instances) && instances.includes(instance) ? instance : null;
  } catch (_) { return null; }
}
function waitForPixel(id) {
  if (readyTimer) clearTimeout(readyTimer);
  const deadline = Date.now() + 15000;
  const check = () => {
    readyTimer = null;
    if (pixelId !== id) return;
    if (activeClient(id)) {
      readyId = id;
      const script = document.querySelector(`script[data-jla-tiktok="${id}"]`);
      if (script) script.dataset.jlaReady = 'true';
      ready();
    } else if (Date.now() < deadline) readyTimer = setTimeout(check, 100);
  };
  check();
}
export function configureTikTokPixel(pixel) {
  const id = pixel?.enabled && /^[a-zA-Z0-9]{10,32}$/.test(pixel.id) ? pixel.id : '';
  if (id !== pixelId) { pixelId = id; readyId = ''; lastPage = ''; if (readyTimer) clearTimeout(readyTimer); readyTimer = null; }
  if (!id) return;
  const w = window;
  // The provider bootstrap is fixed code. Only a validated public pixel ID comes from DB.
  if (!w.ttq) {
    w.TiktokAnalyticsObject = 'ttq';
    const q = w.ttq = [];
    q.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie', 'holdConsent', 'revokeConsent', 'grantConsent'];
    q.setAndDefer = (target, method) => { target[method] = (...args) => target.push([method, ...args]); };
    q.methods.forEach(method => q.setAndDefer(q, method));
    q._i = {}; q._t = {}; q._o = {};
    q.instance = key => { const instance = q._i[key] || []; q.methods.forEach(method => q.setAndDefer(instance, method)); return instance; };
    q.load = key => {
      q._i[key] = []; q._i[key]._u = 'https://analytics.tiktok.com/i18n/pixel/events.js';
      q._t[key] = Date.now(); q._o[key] = {};
      const script = document.createElement('script');
      script.async = true; script.dataset.jlaTiktok = key;
      script.src = `https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=${encodeURIComponent(key)}&lib=ttq`;
      script.addEventListener('error', () => { script.remove(); delete q._i[key]; }, { once: true });
      document.head.appendChild(script);
    };
  }
  if (!w.ttq._i?.[id]) w.ttq.load(id);
  if (readyId !== id || !activeClient(id)) waitForPixel(id);
}
function client() { return pixelId && readyId === pixelId ? activeClient(pixelId) : null; }
export function trackTikTokPage(route) {
  const q = client(); if (!q || !route || lastPage === route) return false;
  try { q.page(); lastPage = route; return true; } catch (_) { return false; }
}
export function trackTikTokView(game, routeId) {
  const q = client(); if (!q || !game) return false;
  const id = String(game.id || game.game_id || routeId || game.game_code || '').trim();
  if (!id) return false;
  const name = game.game_name || game.title || game.name || 'Game top up';
  try { q.track('ViewContent', { content_id: id, content_ids: [id], contents: [{ content_id: id, content_name: name, content_type: 'product', quantity: 1 }], content_type: 'product', content_name: name }); return true; } catch (_) { return false; }
}
export function trackTikTokPurchase(transaction) {
  const purchase = buildMetaPurchase(transaction), q = client();
  if (!purchase || !q) return false;
  const key = `jlastore.tiktok.${pixelId}.purchase.${encodeURIComponent(purchase.transactionId)}`;
  if (safeGetItem(key) === 'sent') return false;
  const p = purchase.parameters;
  try {
    q.track('CompletePayment', { content_id: p.content_ids?.[0] || p.game_id || purchase.transactionId,
      content_ids: p.content_ids || [], content_name: p.content_name, content_type: 'product',
      contents: p.contents?.map(item => ({ content_id: item.id, quantity: item.quantity, price: item.item_price })),
      quantity: 1, value: p.value, currency: p.currency, event_id: purchase.eventID });
    safeSetItem(key, 'sent'); return true;
  } catch (_) { return false; }
}
